import { UserSeatLevel } from '@api/generated/graphql';

export const seatLevelName: Record<UserSeatLevel, string> = {
  [UserSeatLevel.Free]: 'None',
  [UserSeatLevel.Basic]: 'Future Basic',
  [UserSeatLevel.Advanced]: 'Advanced',
};

export const seatLevelPricing: Record<UserSeatLevel, string> = {
  [UserSeatLevel.Free]: 'Free',
  [UserSeatLevel.Basic]: '$X / month',
  [UserSeatLevel.Advanced]: '$X / month',
};

export const seatLevelOrder = [
  UserSeatLevel.Free,
  UserSeatLevel.Basic,
  UserSeatLevel.Advanced,
];

export const WRAPUP_LABEL = 'WRAP_UP';
export const WRAPUP_DISPLAY_NAME = 'Wrap Up';

export const hasValidSeat = (seatLevel?: UserSeatLevel) =>
  seatLevel === UserSeatLevel.Basic || seatLevel === UserSeatLevel.Advanced;
